/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, memo } from 'react';
import Link from 'next/link';
import ContentWrapper from '@components/ContentWrapper';
import { ResponsiveImage } from '@components/Imgix';
import { IconChevronRight } from '@nzxt/react-icons';
import { useTranslation as t } from '@utils/hooks';

import * as styles from './styles';

type CollectionDataProps = {
  slug: string;
  name: string;
};

type Props = {
  collectionData: CollectionDataProps[];
  productName: string;
  productCategory?: string;
};

const ProductNav: FC<Props> = ({
  collectionData,
  productName,
  productCategory,
}) => {
  const SERIES = t('series_label');

  return (
    <div className={styles.innerWrapper} style={{ maxWidth: '100vw' }}>
      <ContentWrapper>
        <div className={styles.breadCrumbWrapper}>
          {collectionData && collectionData.length > 0 ? (
            <>
              <div className={styles.breadCrumb}>
                <Link
                  href={`/collection/${collectionData[0].slug}`}
                  passHref
                  className={styles.breadCrumbItem}
                >
                  {collectionData[0].name.includes('Series')
                    ? collectionData[0].name
                    : `${collectionData[0].name} ${SERIES}`}
                </Link>{' '}
                <IconChevronRight />
                <p className={styles.breadCrumbPageLabel}>{productName}</p>
              </div>
              {productCategory === 'prebuilds' && (
                <div className="hidden md:inline-flex">
                  <ResponsiveImage
                    imageUrl="https://www.datocms-assets.com/34299/1714395008-windows-11_banner_650x95_blue-1.png"
                    imgixParams={{ w: 256, h: 38, auto: 'format' }}
                    height={38}
                    width={256}
                    urlType="srcset"
                    alt="Windows 11"
                    className="w-64"
                  />
                </div>
              )}
            </>
          ) : null}
        </div>
      </ContentWrapper>
    </div>
  );
};

export default memo(ProductNav);
